const CURRENCY = 'GBP';
const ITEM_BRAND = 'Hartridge';

export const pushDataLayerEvent = (event, ecommerce) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ecommerce });
};

export const pushAddToCartEvent = ({ sku, name, price, quantity = 1, coupon }) => {
  pushDataLayerEvent('ga4.eec.add_to_cart', {
    currency: CURRENCY,
    value: Number(price),
    ...(coupon && { coupon }),
    items: [
      {
        item_id: sku,
        item_name: name,
        item_brand: ITEM_BRAND,
        price: Number(price),
        quantity,
      },
    ],
  });
};

export const pushBeginCheckoutEvent = ({ sku, name, price, quantity = 1, coupon }) => {
  pushDataLayerEvent('ga4.eec.begin_checkout', {
    currency: CURRENCY,
    value: Number(price),
    ...(coupon && { coupon }),
    items: [
      {
        item_id: sku,
        item_name: name,
        item_brand: ITEM_BRAND,
        price: Number(price),
        quantity,
      },
    ],
  });
};
export const pushCouponAppliedEvent = ({ coupon, status, value, sku, name }) => {
  pushDataLayerEvent('ga4.eec.coupon_applied', {
    coupon,
    status,
    currency: CURRENCY,
    items: [
      {
        item_id: sku,
        item_name: name,
        item_brand: ITEM_BRAND,
        price: Number(value),
        quantity: 1,
      },
    ],
  });
};

export const pushSignUpEvent = () => {
  pushDataLayerEvent('ga4.sign_up', null);
};

export const pushViewRegistrationEvent = () => {
  pushDataLayerEvent('ga4.view_registration', null);
};

export const pushRegistrationStartEvent = () => {
  pushDataLayerEvent('ga4.registration_start', null);
};

export const pushLoginEvent = () => {
  pushDataLayerEvent('ga4.login', null);
};

export const pushPaymentInfoEvent = ({ paymentMethod, value, sku, name, quantity = 1, coupon }) => {
  pushDataLayerEvent('ga4.eec.add_payment_info', {
    currency: CURRENCY,
    payment_type: paymentMethod,
    ...(value !== undefined && { value: Number(value) }),
    ...(coupon && { coupon }),
    items: [
      {
        item_id: sku,
        item_name: name,
        item_brand: ITEM_BRAND,
        price: Number(value),
        quantity,
      },
    ],
  });
};

export const pushPurchaseEvent = ({ orderId, status, total, subtotal, discount, paymentMethod, sku, productName, quantity = 1 }) => {
  // 'no' for zero-value orders, so expected 0 purchases can be told apart in GA4
  const sellable = Number(total) > 0 ? 'yes' : 'no';

  pushDataLayerEvent('ga4.eec.purchase', {
    transaction_id: orderId,
    currency: CURRENCY,
    value: Number(total),
    ...(discount !== undefined && { discount: Number(discount) || 0 }),
    payment_type: paymentMethod,
    status,
    sellable,
    items: [
      {
        item_id: sku,
        item_name: productName,
        item_brand: ITEM_BRAND,
        price: Number(subtotal),
        quantity,
        sellable,
      },
    ],
  });
};
